/**
 * Convert anything to an array.
 */
export function toArray<T>(arg: T | T[]): T[] {
  return Array.isArray(arg) ? arg : [arg];
}
